import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { api, ApiError } from "../api";
import {
  buildAuthorizeUrl,
  generateState,
  isAuthenticated,
  rememberState,
} from "../auth";
import { useT } from "../i18n";
import { LocaleSwitcher } from "../LocaleSwitcher";

export function LoginPage() {
  const navigate = useNavigate();
  const t = useT();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (isAuthenticated()) {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  async function handleLogin() {
    setBusy(true);
    setError(null);
    try {
      const config = await api.getAuthConfig();
      const state = generateState();
      rememberState(state);
      const url = buildAuthorizeUrl(
        config.authorize_url,
        config.client_id,
        config.callback_url,
        config.scopes,
        state,
      );
      window.location.assign(url);
    } catch (err) {
      const message =
        err instanceof ApiError
          ? typeof err.detail === "string"
            ? err.detail
            : `HTTP ${err.status}`
          : (err as Error).message;
      setError(message);
      setBusy(false);
    }
  }

  return (
    <div className="page">
      <div className="locale-switcher-floating">
        <LocaleSwitcher />
      </div>
      <div className="login-card">
        <h1>{t.loginIntro}</h1>
        <p>{t.loginAccessNote}</p>
        <button onClick={handleLogin} disabled={busy}>
          {busy ? t.loginRedirecting : t.loginButton}
        </button>
        {error && <p className="error">{error}</p>}
      </div>
    </div>
  );
}
